import memoize from 'memoize-one';
import { uniqBy, first } from 'lodash';
import moment from 'moment';
import messages from './simulatedMessages';

export const paginate = memoize((array, page, limit) =>
  array.slice((page - 1) * limit, page * limit),
);

export const filterEvaluations = memoize((evaluations, params) =>
  evaluations.filter((evaluation) => {
    const matchStatus =
      [null, undefined, ''].includes(params.status) ||
      evaluation.dateStatus.status === params.status;
    const matchApplication =
      [null, undefined, ''].includes(params.application) ||
      evaluation.application === params.application;
    const matchYear = params.year === evaluation.year;
    return matchStatus && matchApplication && matchYear;
  }),
);

export const getYears = (evaluations = []) => {
  if (!evaluations.length) return [];
  let auxYear = [];
  const evaluationsYears = uniqBy(evaluations.map((e) => moment(Date.parse(e.date)).year()))
    .sort()
    .reverse();
  if (!evaluationsYears.includes(moment(new Date()).year())) {
    auxYear.push(moment(new Date()).year());
  }

  auxYear = auxYear.concat(evaluationsYears);
  return auxYear;
};

export const getStatus = (evaluations = []) => uniqBy(evaluations.map((e) => e.status));

export const getStatusOptions = (status = [], intl) =>
  status.map((s) => ({
    label: messages[`status_${s}`] ? intl.formatMessage(messages[`status_${s}`]) : s,
    value: s,
  }));

export const getApplicationOptions = (applications = [], intl) =>
  applications.map((a) => ({
    label: messages[`application_${a}`] ? intl.formatMessage(messages[`application_${a}`]) : a,
    value: a,
  }));

export const getCourseOptions = (groups, idCSchool, showStudentsCount = false) => {
  if (!groups || !idCSchool) return [];
  return groups
    .filter((g) => g.idCSchool === idCSchool)
    .map((g) => {
      const label = `${g.levelName} - ${g.courseName}`;
      const hasStudentsCount = g.studentsCount !== undefined && g.studentsCount !== null;
      return {
        label: showStudentsCount && hasStudentsCount ? `${label} (${g.studentsCount} alunos)` : label,
        value: g.idCourse,
      };
    });
};

export const getSchoolOptions = (evaluation) => {
  if (!evaluation) return [];
  return evaluation.schools.map((s) => ({ value: s.idCSchool, label: s.name, schoolType: s.schoolType }));
};

export const getSchoolCSOptions = (evaluation) => {
  if (!evaluation) return [];
  return evaluation.schools.map((s) => ({ value: s.idCSchool, label: s.name }));
};

export const getApplications = (evaluations = []) => uniqBy(evaluations.map((e) => e.application));

export const getEvaluations = (evaluations = []) =>
  evaluations.map((e) => ({
    ...e,
    year: moment.utc(Date.parse(e.date) || new Date()).year(),
    title: e.levelSegment.join(', '),
    abbreviation: e.catalogings && e.catalogings.map((c) => c.abbreviation).join(' | '),
  }));

export const getEvaluationInformation = (data) => {
  const titles = data.evaluation.catalogings.map((el) => el.name);

  if (titles.length === 0) {
    return data;
  }
  if (titles.length === 1) {
    data.title = first(titles);
  } else {
    const lastCataloging = titles[titles.length - 1];
    titles.pop();
    const catalogingsArray = titles.join(', ');
    const catalogings = catalogingsArray.concat(` e ${lastCataloging}`);
    data.title = catalogings;
  }
  return data;
};

export const filterGroupsByEvaluationSchoolLevel = (groups, idCSchool, idLevel) => {
  if (!groups || !idCSchool || !idLevel) return [];

  return groups
    .filter((g) => g.idCSchool === idCSchool && g.idLevel === idLevel)
    .map((g) => ({
      idESCourse: g.idCourse,
      name: `${g.levelName} - ${g.courseName} - ${g.period}`,
      studentsCount: g.studentsCount,
    }));
};

export const getGroupInfo = (groups, idESCourse) => {
  if (!groups || !idESCourse) return [];
  return groups
    .filter((g) => g.idESCourse === parseInt(idESCourse))
    .map((g) => ({
      idESCourse: g.idESCourse,
      name: g.name,
      studentsCount: g.studentsCount,
    }));
};
